import { zodSelectActivityFeedItem } from '../generated/zodSchemas.generated';
import { ensureSubsetOfKeys } from '@daymade/common-lib/types';
import { z } from 'zod';

export const ZActivityFeedItemSelect = zodSelectActivityFeedItem.extend(
  ensureSubsetOfKeys(zodSelectActivityFeedItem.shape, {
    createdAt: z.coerce.date(),
    lastModified: z.coerce.date(),
    placeholderData: z
      .record(
        z.string(),
        z.object({
          value: z.union([z.string(), z.number()]).nullable(),
          important: z.boolean(),
          redirectUrl: z.string().nullable().optional(),
          showIfNull: z.boolean().optional(),
        }),
      )
      .nullable(),
  }),
);

export const ZActivityFeedItemResponse = zodSelectActivityFeedItem
  .pick({
    id: true,
    placeholderData: true,
  })
  .extend({
    iconUrl: z.string().nullable(),
    initials: z.string(),
    text: z.string(),
    timestamp: z.coerce.date(),
  })
  .array();

export type TActivityFeedItemResponse = z.infer<
  typeof ZActivityFeedItemResponse
>;
